import { writable } from 'svelte/store';
export let storeRows = writable({});
export let storeCreating = writable({});
